var ksn = ksn || {};
( function () {
    'use strict';
    jQuery( function () {
        ksn.init();
    } );
    ksn.init = function () {
        ksn.hamburgerIconToggle.init();
        ksn.morphText.init();
        ksn.popupWidget.init();
    };
    ksn.morphText = {
        init: function () {
            jQuery( '.js-rotating' ).Morphext({
                // The [in] animation type. Refer to Animate.css for a list of available animations.
                animation: "fadeInUp",
                // An array of phrases to rotate are created based on this separator. Change it if you wish to separate the phrases differently (e.g. So Simple | Very Doge | Much Wow | Such Cool).
                separator: ",",
                // The delay between the changing of each phrase in milliseconds.
                speed: 4000,
                complete: function () {
                    var currentW = jQuery('.js-rotating').width();
                    jQuery('.js-rotating').parent().css( 'width', jQuery('.js-rotating').parent() + currentW );
                }
            });
        }
    };

    ksn.hamburgerIconToggle = {
        init: function () {
            jQuery( '.e-header-section-content' ).on( 'click', '.js-toggle-hamburger-icon', function ( event ) {
                jQuery( event.target ).closest( '.hamburger' ).toggleClass( 'is-active' );
                jQuery( event.target ).closest( '.e-header-section-content' ).toggleClass( 'js-ksn-open-navigation' );
            } );
        }
    };

    ksn.popupWidget = {
        init: function () {
            jQuery( '.popup-header' ).on( 'click', function( event ) {
                jQuery( this ).parent( '#dwcontentwidget').addClass( 'active');
            } );
            jQuery( '.popup-close' ).on( 'click', function( event ) {
                jQuery( this ).closest( '#dwcontentwidget').removeClass( 'active');
            } );
            setTimeout(function() {
                jQuery('#dwcontentwidget').addClass('active');
                sessionStorage.setItem("popup", true);
            }, 5000);
        }
    };
}() );
